module.exports = __webpack_public_path__ + "img/4.95e2c6df.webp";